import React from "react";

const Price = ()=> {
    return (
        <div>
            <p>Цена</p>
        </div>
    )
}

export default Price;